import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-requestfooter',
  templateUrl: './requestfooter.component.html',
  styleUrls: ['./requestfooter.component.css', './custom_style.css', './boot-outline-btn.css']
})
export class RequestfooterComponent implements OnInit {
  @Input('loan') loan:any;
  constructor() { }

  ngOnInit() {
  }

}
